/* ============================================================================
   KAMSAH - REDESIGN V2 - progressive enhancement layer
   ----------------------------------------------------------------------------
   DRAFT theme "Test Kamsah Redesign V2" only.
   Loaded from snippets/include_script_js.liquid.

   Addresses audit items:
     C2  benefit lines were ~1,100px BELOW the price. Condensed summary is
         lifted directly under the price, above the size selector.
     I2  no reassurance at the point of decision. Trust row under Add to Cart.
     I3  "Notify Me" shown next to in-stock products. Hidden when available.
     Mobile  sticky Add to Cart bar - the single highest-value mobile change.

   Everything is guarded, idempotent, and additive. If a selector is missing
   the feature simply does not run; nothing else is affected.

   TO REVERT: remove the one <script> line in snippets/include_script_js.liquid.

   NOTE FOR A DEVELOPER: this is an enhancement layer so it could be applied
   without rewriting main-product.liquid (56KB). Before this becomes permanent,
   port the benefit summary and trust row into Liquid so they render server-side.
   ========================================================================== */

(function () {
  'use strict';

  var isProduct = document.body.className.indexOf('template-product') !== -1 ||
                  !!document.querySelector('.single_product__details');

  /* ---------- styles for the injected components ------------------------- */
  function injectStyles() {
    if (document.getElementById('k-enhance-styles')) return;
    var css = [
      '.k-benefits{margin:14px 0 4px;padding:0;list-style:none;border-top:1px solid #ECE4D8;border-bottom:1px solid #ECE4D8}',
      '.k-benefits li{padding:10px 0;font-size:14px;line-height:1.5;color:#4C453C;border-bottom:1px solid #F4EEE4}',
      '.k-benefits li:last-child{border-bottom:0}',
      '.k-benefits b{color:#29251F;font-weight:600}',
      '.k-trustrow{display:flex;flex-wrap:wrap;gap:8px 18px;margin:14px 0 0;padding:13px 0 0;border-top:1px solid #ECE4D8;font-size:12.5px;color:#4C453C;line-height:1.4}',
      '.k-trustrow span{display:inline-flex;align-items:center;gap:6px}',
      '.k-trustrow i{font-style:normal;font-size:13px;opacity:.85}',
      '.k-sticky{position:fixed;left:0;right:0;bottom:0;z-index:9998;background:#FCF9F4;border-top:1px solid #DFD5C5;',
      'box-shadow:0 -6px 22px rgba(80,58,34,.13);padding:9px 12px;display:none;align-items:center;gap:10px}',
      '.k-sticky.is-on{display:flex}',
      '.k-sticky__t{flex:1;min-width:0;font-size:12.5px;line-height:1.25;color:#29251F}',
      '.k-sticky__t span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:600}',
      '.k-sticky__t em{font-style:normal;color:#6E6558;font-size:12px}',
      '.k-sticky__b{flex:0 0 auto;background:#A8481F;color:#fff;border:0;border-radius:2px;font-weight:600;',
      'font-size:14px;letter-spacing:.02em;padding:13px 22px;cursor:pointer;font-family:inherit}',
      '.k-sticky__b:active{background:#8A3915}',
      '@media (min-width:769px){.k-sticky{display:none !important}}',
      '@media (max-width:768px){body.k-sticky-pad{padding-bottom:64px}}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'k-enhance-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- helpers ----------------------------------------------------- */
  function firstSentence(txt, cap) {
    txt = (txt || '').replace(/\s+/g, ' ').trim();
    var m = txt.match(/^(.{20,}?[.!?])(\s|$)/);
    var out = m ? m[1] : txt;
    if (out.length > cap) out = out.slice(0, cap).replace(/[\s,;:]+\S*$/, '') + '…';
    return out;
  }

  function findAtcButton() {
    var form = document.querySelector('.single_product__details form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var btns = form.querySelectorAll('button[type="submit"], input[type="submit"], .btn-primary');
    for (var i = 0; i < btns.length; i++) {
      var t = (btns[i].innerText || btns[i].value || '').toLowerCase();
      if (t.indexOf('shop pay') === -1 && t.indexOf('buy with') === -1) return btns[i];
    }
    return btns[0] || null;
  }

  /* ---------- C2: lift the benefit lines above the fold ------------------- */
  function benefitSummary() {
    var wrap = document.querySelector('.single_product__details .details_wrapper');
    var price = document.querySelector('.single_product__details .single_product__price');
    if (!wrap || !price || document.querySelector('.k-benefits')) return;

    var ps = wrap.querySelectorAll(':scope > p');
    var items = [];
    for (var i = 0; i < ps.length && items.length < 3; i++) {
      var p = ps[i];
      var strong = p.querySelector('strong, b');
      if (!strong) continue;

      var full = (p.innerText || '').replace(/\s+/g, ' ').trim();
      if (full.length < 20) continue;

      // Only treat the bold run as a lead-in when it actually OPENS the
      // paragraph. "Thrown and hand-painted in <strong>Nabeul, Tunisia</strong>"
      // must not become "Nabeul, Tunisia — painted in Nabeul, Tunisia...".
      var n = p.firstChild;
      while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
      var opensPara = (n === strong);

      var lead = '', rest = '';
      if (opensPara) {
        lead = (strong.innerText || '').replace(/\s+/g, ' ').trim().replace(/[.:;,—-]\s*$/, '');
        if (lead.length < 4 || lead.length > 60) { lead = ''; }
      }
      if (lead) {
        rest = full.slice(lead.length).replace(/^[\s.:;,—-]+/, '');
        // keep each line short - the audit asked for roughly 12 words
        rest = firstSentence(rest, Math.max(20, 104 - lead.length));
      } else {
        rest = firstSentence(full, 110);
      }
      items.push({ lead: lead, rest: rest });
    }
    if (items.length < 2) return;   // not this kind of product - do nothing

    var ul = document.createElement('ul');
    ul.className = 'k-benefits';
    items.forEach(function (it) {
      var li = document.createElement('li');
      if (it.lead) {
        var b = document.createElement('b');
        b.textContent = it.lead;
        li.appendChild(b);
        // avoid a second em dash when the lead already contains one
        var sep = it.lead.indexOf('—') === -1 ? ' — ' : '. ';
        if (it.rest) li.appendChild(document.createTextNode(sep + it.rest));
      } else {
        li.appendChild(document.createTextNode(it.rest));
      }
      ul.appendChild(li);
    });

    // the wrapper is a flex column driven by `order`; match the buy box (order 1)
    ul.style.order = '1';
    price.parentNode.insertBefore(ul, price.nextSibling);
  }

  /* ---------- I2: reassurance at the point of decision -------------------- */
  function trustRow() {
    if (document.querySelector('.k-trustrow')) return;
    var btn = findAtcButton();
    if (!btn) return;
    var host = btn.closest('.single_product__options') || btn.parentNode;
    if (!host) return;

    var row = document.createElement('div');
    row.className = 'k-trustrow';
    [
      ['🚚', 'Free US shipping over $100'],
      ['↩️', '30-day returns'],
      ['🌱', 'Two trees planted'],
      ['🎨', 'Hand-painted — no two identical']
    ].forEach(function (p) {
      var s = document.createElement('span');
      var i = document.createElement('i');
      i.textContent = p[0];
      s.appendChild(i);
      s.appendChild(document.createTextNode(p[1]));
      row.appendChild(s);
    });
    host.appendChild(row);
  }

  /* ---------- I3: hide "Notify Me" when the variant is in stock ----------- */
  function hideNotifyWhenInStock() {
    var soldOut = /sold\s*out|out of stock/i.test(
      (document.querySelector('.single_product__details') || {}).innerText || ''
    );
    if (soldOut) return;
    var nodes = document.querySelectorAll('.single_product__details a, .single_product__details button, .single_product__details span');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 && /^\s*notify me\s*$/i.test(n.innerText || '')) {
        var t = n.closest('a, button, li, div');
        (t || n).style.display = 'none';
      }
    }
  }

  /* ---------- mobile: sticky Add to Cart ---------------------------------- */
  function stickyAtc() {
    if (window.innerWidth > 768) return;
    if (document.querySelector('.k-sticky')) return;
    var btn = findAtcButton();
    var title = document.querySelector('.single_product__title');
    if (!btn || !title) return;

    var bar = document.createElement('div');
    bar.className = 'k-sticky';
    var info = document.createElement('div');
    info.className = 'k-sticky__t';
    var nm = document.createElement('span');
    nm.textContent = (title.innerText || '').trim();
    var pr = document.createElement('em');
    var priceEl = document.querySelector('.single_product__price');
    pr.textContent = priceEl ? (priceEl.innerText || '').replace(/\s+/g, ' ').trim() : '';
    info.appendChild(nm);
    info.appendChild(pr);

    var go = document.createElement('button');
    go.className = 'k-sticky__b';
    go.type = 'button';
    go.textContent = 'Add to Cart';
    go.addEventListener('click', function () { btn.click(); });

    bar.appendChild(info);
    bar.appendChild(go);
    document.body.appendChild(bar);
    document.body.classList.add('k-sticky-pad');

    // keep the price in the bar in sync when a variant changes
    if (priceEl && window.MutationObserver) {
      new MutationObserver(function () {
        pr.textContent = (priceEl.innerText || '').replace(/\s+/g, ' ').trim();
      }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    function toggle() {
      var r = btn.getBoundingClientRect();
      var gone = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-on', gone);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
  }

  /* ---------- run --------------------------------------------------------- */
  function run() {
    try { injectStyles(); } catch (e) {}
    if (!isProduct) return;
    try { benefitSummary(); } catch (e) {}
    try { trustRow(); } catch (e) {}
    try { hideNotifyWhenInStock(); } catch (e) {}
    try { stickyAtc(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // the theme re-renders parts of the buy box on variant change
  window.addEventListener('load', function () { setTimeout(run, 400); });
})();
